// src/components/admin/layout/AdminHeader.jsx
import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Badge,
  Chip,
  Button
} from '@mui/material';
import {
  Menu as MenuIcon,
  Notifications,
  Logout,
  Settings,
  AccountCircle
} from '@mui/icons-material';
import { useSelector, useDispatch } from 'react-redux';
import { selectFeedbackStats } from '../../../store/slices/adminFeedbackSlice';
import { logout, selectUser } from '../../../store/slices/authSlice';
import { useNavigate } from 'react-router-dom';

const AdminHeader = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [notificationAnchor, setNotificationAnchor] = React.useState(null);
  const stats = useSelector(selectFeedbackStats);
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNotificationClick = (event) => {
    setNotificationAnchor(event.currentTarget);
  };

  const handleNotificationClose = () => {
    setNotificationAnchor(null);
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate('/admin/login');
    handleClose();
  };

  const newFeedbackCount = stats?.new || 0;

  return (
    <AppBar position="static" elevation={1}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        {/* Лява част */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {/* <IconButton
            size="large"
            edge="start"
            color="inherit"
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton> */}
          <Typography variant="h6" noWrap component="div">
            Административен Панел
          </Typography>
          
          {newFeedbackCount > 0 && (
            <Chip
              label={`${newFeedbackCount} нови сигнала`}
              color="error"
              size="small"
              sx={{ ml: 2 }}
            />
          )}
        </Box>

        {/* Дясна част */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {/* Потребителско име */}
          {user && (
            <Typography variant="body2" sx={{ mr: 1 }}>
              {user.username}
            </Typography>
          )}
          
          {/* Нотификации */}
          <IconButton
            size="large"
            color="inherit"
            onClick={handleNotificationClick}
          >
            <Badge badgeContent={newFeedbackCount} color="error">
              <Notifications />
            </Badge>
          </IconButton>

          <Menu
            anchorEl={notificationAnchor}
            open={Boolean(notificationAnchor)}
            onClose={handleNotificationClose}
          >
            {newFeedbackCount > 0 ? (
              <MenuItem onClick={handleNotificationClose}>
                Имате {newFeedbackCount} нови сигнала за обратна връзка
              </MenuItem>
            ) : (
              <MenuItem onClick={handleNotificationClose}>
                Няма нови нотификации
              </MenuItem>
            )}
          </Menu>

          {/* Профил меню */}
          <IconButton
            size="large"
            onClick={handleMenu}
            color="inherit"
          >
            <AccountCircle />
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={handleClose}>
              <Settings sx={{ mr: 1 }} />
              Настройки
            </MenuItem>
            <MenuItem onClick={handleLogout}>
              <Logout sx={{ mr: 1 }} />
              Изход
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default AdminHeader;